import React from 'react';
import CheckListContainer from '../components/c-checklist-container';

export default (props) => {
  return <CheckListContainer {...props} />;
};
